export default "__VITE_ASSET__CMBGqMb9__"